module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    staticClass: "no-wrap",
    attrs: {
      "md": 3,
      "lg": 3
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.addDialogShow
    }
  }, [_vm._v("新建到店签到活动")])], 1)], 1), _vm._v(" "), _c('el-alert', {
    staticClass: "rule-alert",
    attrs: {
      "type": "warning",
      "closable": false,
      "show-icon": "",
      "title": "小程序端同一时刻只有一个活动对外生效",
      "description": "生效规则：状态为「启用」 + 当前时间落在活动时间范围内 + 创建时间最新。同时启用多个活动时，其余活动不会生效。另：活动时间留空时，开始时间取当前时间、结束时间取当年 12-31 23:59:59，跨年后需延长结束时间，否则活动会静默失效。"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "",
      "prop": "id",
      "label": "序号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "活动名称",
      "width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name))]), _vm._v(" "), (scope.row.id === _vm.currentActiveId) ? _c('el-tag', {
          staticClass: "active-tag",
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("当前生效")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "start_time",
      "label": "开始时间",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "end_time",
      "label": "结束时间",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "distance_threshold",
      "label": "到店距离阈值(米)",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == '1') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("启用")]) : _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("禁用")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "创建时间",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.detailDialogShow(scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.editDialogShow(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.delActivity(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total_count > _vm.searchParams.pagesize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.searchParams.page,
      "total": _vm.total_count,
      "page-size": _vm.searchParams.pagesize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.searchParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.searchParams, "page", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建到店签到活动",
      "width": "80%",
      "visible": _vm.addDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.addDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.addData,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "placeholder": "请输入活动名称"
    },
    model: {
      value: (_vm.addData.name),
      callback: function($$v) {
        _vm.$set(_vm.addData, "name", $$v)
      },
      expression: "addData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.addData.timeRange),
      callback: function($$v) {
        _vm.$set(_vm.addData, "timeRange", $$v)
      },
      expression: "addData.timeRange"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "frm-tips",
    attrs: {
      "span": 10
    }
  }, [_vm._v("不选择则开始时间取当前时间、结束时间取当年 12-31 23:59:59")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-value": "1",
      "inactive-value": "2"
    },
    model: {
      value: (_vm.addData.status),
      callback: function($$v) {
        _vm.$set(_vm.addData, "status", $$v)
      },
      expression: "addData.status"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "到店距离阈值"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    on: {
      "input": function($event) {
        return _vm.handleThresholdInt('add')
      }
    },
    model: {
      value: (_vm.addData.distance_threshold),
      callback: function($$v) {
        _vm.$set(_vm.addData, "distance_threshold", $$v)
      },
      expression: "addData.distance_threshold"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "frm-tips",
    attrs: {
      "span": 12
    }
  }, [_vm._v("单位：米。会员与门店的距离需小于等于该值才可签到")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "到店签到图片"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('daily_sign_img')
      }
    }
  }, [(_vm.addData.daily_sign_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.addData.daily_sign_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("注：签到图标图片，只能上传jpg/png文件，且不超过500KB")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "连续签到奖励"
    }
  }), _vm._v(" "), _vm._l((_vm.addData.award), function(item, index) {
    return _c('el-form-item', {
      key: index
    }, [_c('el-col', {
      staticClass: "form-label",
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("类型：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择",
        "size": "small"
      },
      model: {
        value: (item.award_type),
        callback: function($$v) {
          _vm.$set(item, "award_type", $$v)
        },
        expression: "item.award_type"
      }
    }, _vm._l((_vm.awardOptions), function(opt) {
      return _c('el-option', {
        key: opt.value,
        attrs: {
          "label": opt.label,
          "value": opt.value
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-col', {
      staticClass: "form-label",
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("连续天数：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": "如 3"
      },
      model: {
        value: (item.period_num),
        callback: function($$v) {
          _vm.$set(item, "period_num", $$v)
        },
        expression: "item.period_num"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticClass: "form-label",
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("奖励内容：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": item.award_type === 'points' ? '积分数' : '优惠券ID'
      },
      model: {
        value: (item.award_content),
        callback: function($$v) {
          _vm.$set(item, "award_content", $$v)
        },
        expression: "item.award_content"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticClass: "form-label",
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("描述：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": "请输入奖品描述"
      },
      model: {
        value: (item.award_description),
        callback: function($$v) {
          _vm.$set(item, "award_description", $$v)
        },
        expression: "item.award_description"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticClass: "form-label",
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("展示图片：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('div', {
      staticClass: "upload-box upload-box-mini",
      on: {
        "click": function($event) {
          return _vm.handleImgPicker('continuous_sign_img', index)
        }
      }
    }, [(item.image) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": item.image
      }
    }) : _c('i', {
      staticClass: "iconfont icon-camera avatar-uploader-icon"
    })])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeAward(item)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.addPeriod
    }
  }, [_vm._v("新增连续签到奖励")]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips award-tips"
  }, [_vm._v("注：连续天数从 1 开始配置，「连续第 1 天」即每次到店签到的基础奖励，必须配置，否则会员签到后拿不到任何奖励；奖励类型选「积分」时奖励内容填积分数量，选「优惠券」时填卡券ID（小程序端凭该ID发券）。")])], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.btnLoading
    },
    on: {
      "click": _vm.newActivity
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑到店签到活动",
      "width": "80%",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.editData,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.editData.name),
      callback: function($$v) {
        _vm.$set(_vm.editData, "name", $$v)
      },
      expression: "editData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: (_vm.editData.timeRange),
      callback: function($$v) {
        _vm.$set(_vm.editData, "timeRange", $$v)
      },
      expression: "editData.timeRange"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "frm-tips",
    attrs: {
      "span": 10
    }
  }, [_vm._v("不选择则开始时间取当前时间、结束时间取当年 12-31 23:59:59；活动仅在该时间范围内对小程序端生效")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-value": "1",
      "inactive-value": "2"
    },
    model: {
      value: (_vm.editData.status),
      callback: function($$v) {
        _vm.$set(_vm.editData, "status", $$v)
      },
      expression: "editData.status"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "到店距离阈值"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    on: {
      "input": function($event) {
        return _vm.handleThresholdInt('edit')
      }
    },
    model: {
      value: (_vm.editData.distance_threshold),
      callback: function($$v) {
        _vm.$set(_vm.editData, "distance_threshold", $$v)
      },
      expression: "editData.distance_threshold"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "frm-tips",
    attrs: {
      "span": 12
    }
  }, [_vm._v("单位：米。会员与门店的距离需小于等于该值才可签到")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "到店签到图片"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('daily_sign_img')
      }
    }
  }, [(_vm.editData.daily_sign_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.editData.daily_sign_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("注：签到图标图片，只能上传jpg/png文件，且不超过500KB")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "连续签到奖励"
    }
  }), _vm._v(" "), _vm._l((_vm.editData.award), function(item, index) {
    return _c('el-form-item', {
      key: index
    }, [_c('el-col', {
      staticClass: "form-label",
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("类型：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "请选择",
        "size": "small"
      },
      model: {
        value: (item.award_type),
        callback: function($$v) {
          _vm.$set(item, "award_type", $$v)
        },
        expression: "item.award_type"
      }
    }, _vm._l((_vm.awardOptions), function(opt) {
      return _c('el-option', {
        key: opt.value,
        attrs: {
          "label": opt.label,
          "value": opt.value
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-col', {
      staticClass: "form-label",
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("连续天数：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": "如 3"
      },
      model: {
        value: (item.period_num),
        callback: function($$v) {
          _vm.$set(item, "period_num", $$v)
        },
        expression: "item.period_num"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticClass: "form-label",
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("奖励内容：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": item.award_type === 'points' ? '积分数' : '优惠券ID'
      },
      model: {
        value: (item.award_content),
        callback: function($$v) {
          _vm.$set(item, "award_content", $$v)
        },
        expression: "item.award_content"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticClass: "form-label",
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("描述：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-input', {
      attrs: {
        "size": "small",
        "placeholder": "请输入奖品描述"
      },
      model: {
        value: (item.award_description),
        callback: function($$v) {
          _vm.$set(item, "award_description", $$v)
        },
        expression: "item.award_description"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticClass: "form-label",
      attrs: {
        "span": 1.5
      }
    }, [_vm._v("展示图片：")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('div', {
      staticClass: "upload-box upload-box-mini",
      on: {
        "click": function($event) {
          return _vm.handleImgPicker('continuous_sign_img', index)
        }
      }
    }, [(item.image) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": item.image
      }
    }) : _c('i', {
      staticClass: "iconfont icon-camera avatar-uploader-icon"
    })])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "type": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeEditAward(item)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.addEditPeriod
    }
  }, [_vm._v("新增连续签到奖励")]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips award-tips"
  }, [_vm._v("注：连续天数从 1 开始配置，「连续第 1 天」即每次到店签到的基础奖励，必须配置，否则会员签到后拿不到任何奖励；奖励类型选「积分」时奖励内容填积分数量，选「优惠券」时填卡券ID（小程序端凭该ID发券）。")])], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.btnLoading
    },
    on: {
      "click": _vm.editActivity
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看到店签到活动",
      "width": "80%",
      "visible": _vm.viewDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.viewDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.detailData,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.detailData.name),
      callback: function($$v) {
        _vm.$set(_vm.detailData, "name", $$v)
      },
      expression: "detailData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开始时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.detailData.start_time),
      callback: function($$v) {
        _vm.$set(_vm.detailData, "start_time", $$v)
      },
      expression: "detailData.start_time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结束时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.detailData.end_time),
      callback: function($$v) {
        _vm.$set(_vm.detailData, "end_time", $$v)
      },
      expression: "detailData.end_time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [(_vm.detailData.status == '1') ? _c('el-tag', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("启用")]) : _c('el-tag', {
    attrs: {
      "type": "info"
    }
  }, [_vm._v("禁用")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "到店距离阈值"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "value": _vm.detailData.distance_threshold + ' 米',
      "disabled": ""
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "到店签到图片"
    }
  }, [_c('div', {
    staticClass: "upload-box upload-box-view"
  }, [(_vm.detailData.daily_sign_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.detailData.daily_sign_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖励配置"
    }
  }), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.detailData.award,
      "border": "",
      "size": "small"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "day",
      "label": "连续天数",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "award_type",
      "label": "奖励类型",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.award_type == 'points') ? _c('el-tag', [_vm._v("积分")]) : _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("优惠券")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "award_content",
      "label": "奖励内容",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "award_description",
      "label": "描述"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "image",
      "label": "展示图片",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.image) ? _c('img', {
          staticClass: "award-img",
          attrs: {
            "src": scope.row.image
          }
        }) : _c('span', [_vm._v("-")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewDialog = false
      }
    }
  }, [_vm._v("关 闭")])], 1)], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-77a89126", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77a89126"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/storeSigninActivity/list.vue
// module id = 2839
// module chunks = 0